/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MuDataProcessingJoinersCustomPlaceCrossingDriver,
    MuDataProcessingJoinersCustomPlaceCrossingDriverFromJSON,
    MuDataProcessingJoinersCustomPlaceCrossingDriverFromJSONTyped,
    MuDataProcessingJoinersCustomPlaceCrossingDriverToJSON,
} from './';

/**
 * 
 * @export
 * @interface MuDataProcessingJoinersCustomPlaceCrossingManual
 */
export interface MuDataProcessingJoinersCustomPlaceCrossingManual {
    /**
     * 
     * @type {MuDataProcessingJoinersCustomPlaceCrossingDriver}
     * @memberof MuDataProcessingJoinersCustomPlaceCrossingManual
     */
    driver: MuDataProcessingJoinersCustomPlaceCrossingDriver;
}

export function MuDataProcessingJoinersCustomPlaceCrossingManualFromJSON(json: any): MuDataProcessingJoinersCustomPlaceCrossingManual {
    return MuDataProcessingJoinersCustomPlaceCrossingManualFromJSONTyped(json, false);
}

export function MuDataProcessingJoinersCustomPlaceCrossingManualFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingJoinersCustomPlaceCrossingManual {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driver': MuDataProcessingJoinersCustomPlaceCrossingDriverFromJSON(json['driver']),
    };
}

export function MuDataProcessingJoinersCustomPlaceCrossingManualToJSON(value?: MuDataProcessingJoinersCustomPlaceCrossingManual | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver': MuDataProcessingJoinersCustomPlaceCrossingDriverToJSON(value.driver),
    };
}


